export class CorreoParDto {
    periodo: string;
	nombreEvaluado: string;
	correoEvaluador: string;
    codigoEvaluador: number;
	asunto: string;
}
